import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Title, Section } from 'components/layout'
import { Button } from 'components/misc'
import {
  apiActivities
} from 'helpers/decorators/api'

@apiActivities()
class AssessorSendWelcomeEmail extends Component {
  static propTypes = {
    id: PropTypes.number,
    activities: PropTypes.object,
    modal: PropTypes.func.isRequired,
    sendAssessorWelcomeEmail: PropTypes.func.isRequired
  }

  render() {
    const {
      id,
      activities
    } = this.props

    return (
      <Section>
        <Title className="text--center" h2 intlKey="moduleTitle.are_you_sure">
          Are you sure?
        </Title>
        <div className="row">
          <div className="col-xs-6">
            <Button
              secondary
              onClick={() => this.props.modal(null)}
              intlKey="button.close"
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              onClick={() => this.props.sendAssessorWelcomeEmail(id)}
              isLoading={activities.loading}
              intlKey="button.send"
            >
              Send
            </Button>
          </div>
        </div>
      </Section>
    )
  }
}

export default AssessorSendWelcomeEmail
